export const showFilterPanel = (tableType) => ((tableType !== 'categories') && (tableType !== 'entries') && (tableType !== 'usersUpload') && (tableType !== 'jobs'));
